import { render, staticRenderFns } from "./Egg.vue?vue&type=template&id=1a5adbce&scoped=true&"
import script from "./Egg.vue?vue&type=script&lang=js&"
export * from "./Egg.vue?vue&type=script&lang=js&"
import style0 from "./Egg.vue?vue&type=style&index=0&id=1a5adbce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5adbce",
  null
  
)

export default component.exports